import { ssv2341ConfiCrtorFlagWsResource } from '@/shared/api.resource';

import {
  FETCH_SSV2341_CONFI_CRTOR_FLAG_WS_BY_ID,
  FETCH_PAGINATED_SSV2341_CONFI_CRTOR_FLAG_WSS,
  UPDATE_SSV2341_CONFI_CRTOR_FLAG_WS,
  CREATE_SSV2341_CONFI_CRTOR_FLAG_WS,
  DELETE_SSV2341_CONFI_CRTOR_FLAG_WS,
  RESET_SSV2341_CONFI_CRTOR_FLAG_WS_FILTERS,
  RESET_SSV2341_CONFI_CRTOR_FLAG_WS,
  RESET_SSV2341_CONFI_CRTOR_FLAG_WSS_LIST,
} from './actions.type';

import {
  SET_SSV2341_CONFI_CRTOR_FLAG_WS,
  SET_PAGINATED_SSV2341_CONFI_CRTOR_FLAG_WSS,
  RESET_STATE_SSV2341_CONFI_CRTOR_FLAG_WS_FILTERS,
  RESET_STATE_SSV2341_CONFI_CRTOR_FLAG_WS,
  RESET_STATE_SSV2341_CONFI_CRTOR_FLAG_WS_LIST,
} from './mutations.type';

const initialState = {
  ssv2341ConfiCrtorFlagWsFilters: {},
  ssv2341ConfiCrtorFlagWs: {},
  paginatedSsv2341ConfiCrtorFlagWss: {
    content: [],
    totalElements: 0,
    size: 0
  }
};

export const state = JSON.parse(JSON.stringify(initialState));

export const actions = {
  async [FETCH_SSV2341_CONFI_CRTOR_FLAG_WS_BY_ID](context, id) {
    const { data } = await ssv2341ConfiCrtorFlagWsResource.get({ id: id });
    context.commit(SET_SSV2341_CONFI_CRTOR_FLAG_WS, data);
    return data;
  },
  async [FETCH_PAGINATED_SSV2341_CONFI_CRTOR_FLAG_WSS](context, params) {
    const { data } = await ssv2341ConfiCrtorFlagWsResource.query(params);
    context.commit(SET_PAGINATED_SSV2341_CONFI_CRTOR_FLAG_WSS, data);
    return data;
  },
  async [CREATE_SSV2341_CONFI_CRTOR_FLAG_WS](context) {
    const { data } = await ssv2341ConfiCrtorFlagWsResource.save(state.ssv2341ConfiCrtorFlagWs);
    context.commit(SET_SSV2341_CONFI_CRTOR_FLAG_WS, data);
    return data;
  },
  async [UPDATE_SSV2341_CONFI_CRTOR_FLAG_WS](context, id) {
    const { data } = await ssv2341ConfiCrtorFlagWsResource.update({ id: id }, state.ssv2341ConfiCrtorFlagWs);
    context.commit(SET_SSV2341_CONFI_CRTOR_FLAG_WS, data);
    return data;
  },
  [DELETE_SSV2341_CONFI_CRTOR_FLAG_WS](context, id) {
    return ssv2341ConfiCrtorFlagWsResource.delete({ id: id });
  },
  [RESET_SSV2341_CONFI_CRTOR_FLAG_WS_FILTERS]({ commit }) {
    commit(RESET_STATE_SSV2341_CONFI_CRTOR_FLAG_WS_FILTERS);
  },
  [RESET_SSV2341_CONFI_CRTOR_FLAG_WS]({ commit }) {
    commit(RESET_STATE_SSV2341_CONFI_CRTOR_FLAG_WS);
  },
  [RESET_SSV2341_CONFI_CRTOR_FLAG_WSS_LIST]({ commit }) {
    commit(RESET_STATE_SSV2341_CONFI_CRTOR_FLAG_WS_LIST);
  }
};

export const mutations = {
  [SET_SSV2341_CONFI_CRTOR_FLAG_WS](state, ssv2341ConfiCrtorFlagWs) {
    state.ssv2341ConfiCrtorFlagWs = ssv2341ConfiCrtorFlagWs;
  },
  [SET_PAGINATED_SSV2341_CONFI_CRTOR_FLAG_WSS](state, paginatedSsv2341ConfiCrtorFlagWss) {
    state.paginatedSsv2341ConfiCrtorFlagWss = paginatedSsv2341ConfiCrtorFlagWss;
  },
  [RESET_STATE_SSV2341_CONFI_CRTOR_FLAG_WS](state) {
    state.ssv2341ConfiCrtorFlagWs = JSON.parse(JSON.stringify(initialState.ssv2341ConfiCrtorFlagWs));
  },
  [RESET_STATE_SSV2341_CONFI_CRTOR_FLAG_WS_FILTERS](state) {
    state.ssv2341ConfiCrtorFlagWsFilters = JSON.parse(JSON.stringify(initialState.ssv2341ConfiCrtorFlagWsFilters));
  },
  [RESET_STATE_SSV2341_CONFI_CRTOR_FLAG_WS_LIST](state) {
    state.paginatedssv2341ConfiCrtorFlagWss = JSON.parse(JSON.stringify(initialState.paginatedSsv2341ConfiCrtorFlagWss));
  }
};

export const getters = {
  ssv2341ConfiCrtorFlagWs(state) {
    return state.ssv2341ConfiCrtorFlagWs;
  },
  ssv2341ConfiCrtorFlagWsFilters(state) {
    return state.ssv2341ConfiCrtorFlagWsFilters;
  },
  paginatedSsv2341ConfiCrtorFlagWss(state) {
    return state.paginatedSsv2341ConfiCrtorFlagWss;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
}